import { render } from "./Cooperatives.vue?vue&type=template&id=d530ed1e"
import script from "./Cooperatives.vue?vue&type=script&lang=js"
export * from "./Cooperatives.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mahoro\\projects\\crane\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__